import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { accountSettingsRoute } from 'src/app/app-routing.module';
import { LcsDialogService } from 'src/app/common-components/dialog/dialog.service';
import { AccountDetailSaveModel } from '../../account-details/models/account-detail-save.model';
import { AddAccountApiService } from '../services/add-account-api.service';
import * as AddAccountActions from './add-account.actions';

@Injectable()
export class AddAccountEffects {
   createAccount$ = createEffect(() => {
      return this.actions$.pipe(
         ofType(AddAccountActions.createAccount),
         switchMap((action) => {
            const accountToSave: AccountDetailSaveModel = {
               ...action.account,
            };
            return this.addAccountApiService.createNewAccount(accountToSave).pipe(
               map((executionResult) => {
                  return AddAccountActions.createAccountSuccess({
                     accountId: executionResult.body ?? 0,
                     accountName: null,
                  });
               }),
               catchError((error) => {
                  return of(AddAccountActions.createAccountFailure(error));
               })
            );
         })
      );
   });
   createAccountSuccess$ = createEffect(
      () => {
         return this.actions$.pipe(
            ofType(AddAccountActions.createAccountSuccess),
            tap((result) => {
               this.dialogService.closeFormComponent();
               this.router.navigate([`/${accountSettingsRoute}/${result.accountId}`]);
               this.snackbar.open(`Account Created`);
            })
         );
      },
      {
         dispatch: false,
      }
   );

   constructor(
      private actions$: Actions,
      private addAccountApiService: AddAccountApiService,
      private snackbar: MatSnackBar,
      private dialogService: LcsDialogService,
      private router: Router
   ) {}
}
